import { useState, useEffect, useRef } from "react";
import SuccessMessage from "../../../components/SuccessMessage";
import Constants from "../../../Constants";
import { RotatingLines } from "react-loader-spinner";
import jQuery from "jquery";

export default function EloquaCredential(props) {

  const companyNameRef = useRef("");
  const userNameRef = useRef("");
  const passwordRef = useRef("");

  const credentialData = props.credentialData;
  const [errorMessages, setErrorMessages] = useState(props.errorMessages);
  const [successMessage, setSuccessMessage] = useState(props.successMessage);
  const [companyName, setCompanyName] = useState(companyNameRef.current?.value);
  const [username, setUsername] = useState(userNameRef.current?.value);
  const [password, setPassword] = useState(passwordRef.current?.value); 

  

  useEffect(() => {
    if (props.errorMessages?.length > 0) {
      setErrorMessages(props.errorMessages)
    }
  }, [props.errorMessages])

  useEffect(()=>{
    if(props.successMessage!==Constants.BLANK){
      setSuccessMessage(props.successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
        //props.closePopup();
      },5000);
    }
  },[props.successMessage]);

  useEffect(() => {
    const saveCredentialButton = jQuery("#save-credential");
    const validateEloquaCredButton = jQuery("#validateEloquaCred");
    if (companyName?.length > 0 && username?.length > 0 && password?.length > 0) {
      saveCredentialButton?.removeAttr("disabled");
      validateEloquaCredButton?.removeAttr("disabled");
    } else {
      saveCredentialButton?.attr("disabled",  "true")
      validateEloquaCredButton?.attr("disabled", "true")
    }
  }, [companyName, username, password]);


  const onChnageInputFields = () => {
    setCompanyName(companyNameRef.current?.value);
    setUsername(userNameRef.current?.value);
    setPassword(passwordRef.current?.value)
  }

  return (
    <>
    <div className={props.isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
        <RotatingLines
          strokeColor="#0096FF"
          strokeWidth="5"
          width="196"
          visible={true}
        />
      </div>
    </div> 

    {errorMessages?.length > 0 &&
      <><span id="eloquaServerError" className="error">
      {errorMessages?.map(error => {
        return (<li>{JSON.stringify(error)}</li>) 
      })}
      </span><br/></>
    }

    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}
      
      <>
      <div className="global-dropdown-block mr-0">
        <label>Company Name</label>
        <div className="global-dropdown-select">
          <input id="eloqua-company-name-input" type="text" className="form-control-sm" placeholder="Company Name" 
          defaultValue={credentialData?.credentials?.COMPANY_NAME} ref={companyNameRef} onChange={() => onChnageInputFields()} 
          />                    
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Eloqua Username</label>
        <div className="global-dropdown-select">
          <input id="eloqua-username-input" type="text" className="form-control-sm" placeholder="Eloqua username" 
          defaultValue={credentialData?.credentials?.USERNAME} ref={userNameRef} onChange={() => onChnageInputFields()} 
          />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Eloqua Password</label>
        <div className="global-dropdown-select">
          <input id="eloqua-password-input" type="password" className="form-control-sm" placeholder="Eloqua password" 
          ref={passwordRef} 
          onChange={() => onChnageInputFields()} 
          />                              
        </div>
      </div>
      </>
      
    </>
  )
}


